import config from "@tailwind-config"

export interface SwatchProps {
  value: number
  name: string
}

interface ColorSamplesProps {
  name: string
  className: string
}

const LEVELS = [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]
const INVERT: Record<string, number> = {
  gray: 700,
  pink: 700,
  red: 500,
  orange: 700,
  yellow: 900,
  green: 800,
  teal: 700,
  blue: 600,
  indigo: 600,
  purple: 600,
  neutral: 700,
  emphatic: 600,
  success: 800,
  alert: 900,
  problem: 500,
}

export const ColorSamples = (props: ColorSamplesProps) => {
  const { name, className } = props
  const levels: Record<string, string> = config.theme.colors[name]

  return (
    <div className={className}>
      {LEVELS.map((level) => {
        const threshold = INVERT[name]
        const textColor = level >= threshold ? "text-white" : "text-black"

        return (
          <div
            key={level}
            className={`p-3 ${textColor}`}
            style={{ backgroundColor: levels[level] }}
          >
            {name}-{level}
          </div>
        )
      })}
    </div>
  )
}
